<app-nav></app-nav>
<Section class="submission">
  <!-- view card starts -->
  <div class="modal-container-vm ">
    <div class="modal-overlay-vm"></div>
    <div class="modal-card-vm">
      <p class="sub-title mt-4">E-cards</p>

      <div class="home-tabs">
        <ul>
          <li (click)="policyPart=true;editPolicyPart=false;renewPolicyPart=false;claimPart=false;"
            [ngClass]="{ 'active': policyPart}">Policy</li>
          <li class="edit">Edit</li>
          <li class="renew">Renew</li>
          <li (click)="policyPart=false;editPolicyPart=false;renewPolicyPart=false;claimPart=true;"
            [ngClass]="{'active': claimPart}" routerLink="/register">Claim</li>
        </ul>
      </div>

      <div class="row mt-4 logo-position">
        <div class="col-4">
          <img class="insurerLogo ml-4" src="{{insurerLogo}}" alt="">
        </div>
        <div class="col-4">
          <h4 class="policyName ml-2">{{this.policyName}}</h4>
        </div>
        <div class="col-4 sn-logo">
          <img class="insurerLogo" src="	https://static-files-website.s3.ap-south-1.amazonaws.com/securenow_logo.svg" alt="">
        </div>
      </div>
      <section *ngIf="policyPart">
        <div class="pt-2 content-box mt-2">
          <div class="row">
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Card Number</div>
              <div class="row cardFieldsVal">{{this.cardNumber}}</div>
            </div>
            <div class="col-md-2 col-6 mt-4">
              <span class="row cardFields">Insured</span>
              <span class="row cardFieldsVal">{{this.insured}}</span>
            </div>

            <!-- <div class="mt-4"> -->
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Gender</div>
              <div class="row cardFieldsVal">{{this.gender}}</div>
            </div>
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Relation</div>
              <div class="row cardFieldsVal">{{this.relation}}</div>
            </div>
            <!-- </div>
            <div class=" mt-4"> -->
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Sum Insured</div>
              <div class="row cardFieldsVal">{{this.sumInsured}}</div>
            </div>

            <!-- <div class="col-md-2 col-6 mt-4">
              <span class="row cardFields">Company</span>
              <span class="row cardFieldsVal">{{this.company}}</span>
            </div> -->

            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Policy Holder</div>
              <div class="row cardFieldsVal">{{this.policyHolder}}</div>
            </div> 

            <!-- </div>
            <div class=" mt-4"> -->
            <div class="col-md-2 col-12 mt-4">
              <div class="row cardFields">Email</div>
              <div class="row cardFieldsVal">{{this.email}}</div>
            </div>
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Mobile</div>
              <div class="row cardFieldsVal">{{this.mobile}}</div>
            </div>
            <!-- </div>
            <div class=" mt-4"> -->
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Employee Id</div>
              <div class="row cardFieldsVal">{{this.employeeId}}</div>
            </div>
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Policy No.</div>
              <div class="row cardFieldsVal">{{this.policyNumber}}</div>
            </div>
            <!-- </div>
            <div class=" mt-4"> -->
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Insurer</div>
              <div class="row cardFieldsVal">{{this.insurer}}</div>
            </div>
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Policy Cover Type</div>
              <div class="row cardFieldsVal">{{this.policyCoverType}}</div>
            </div>
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Maternity</div>
              <div class="row cardFieldsVal">{{this.maternity}}</div>
            </div>
            <!-- </div>
            <div class=" mt-4"> -->
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Room Rent</div>
              <div class="row cardFieldsVal">{{this.roomRent}}</div>
            </div>
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Cataract Limit</div>
              <div class="row cardFieldsVal">{{this.contractLimit}}</div>
            </div>
            <!-- </div>
            <div class=" mt-4"> -->
            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Policy Name</div>
              <div class="row cardFieldsVal">{{this.policyName}}</div>
            </div>

            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Date of Birth</div>
              <div class="row cardFieldsVal">{{this.dob ? (this.dob | date) : "NA"}}</div>
            </div>

            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Age</div>
              <div class="row cardFieldsVal">{{this.Age}}</div>
            </div>

            <!-- <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Policy Holder</div>
              <div class="row cardFieldsVal">{{this.policyHolder}}</div>
            </div>  -->

            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">TPA NAME</div>
              <div class="row cardFieldsVal">{{this.TPA_NAME}}</div>
            </div>  

            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Overall Copay</div>
              <div class="row cardFieldsVal">{{this.coPay}}</div>
            </div>

            <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Disease Limit</div>
              <div class="row cardFieldsVal">{{this.diseaseLimit}}</div>
            </div>
            <ng-container *ngIf="isClietNFI">
              <div class="col-md-2 col-6 mt-4">
                <div class="row cardFields">CSO Name</div>
                <div class="row cardFieldsVal">{{this.csoName}}</div>
              </div>
            </ng-container>
             <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Policy Start Date</div>
              <div class="row cardFieldsVal">{{this.policyStartDate}}</div>
            </div>
              <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Policy End Date</div>
              <div class="row cardFieldsVal">{{this.policyEndDate}}</div>
            </div>
             <div class="col-md-2 col-6 mt-4">
              <div class="row cardFields">Policy Joining Date</div>
              <div class="row cardFieldsVal">{{this.policyJoiningDate}}</div>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </section>

      <!-- <section *ngIf="claimPart">
        <div *ngIf="!intimateSuccessfull && !intimateFailure">


          <div class="container">
            <div class="col">
              <form #formClaimIntimate="ngForm">
                <div class=" row sum-container">
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Insurer</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input type="text" class="form-control" name="insurer" id="insurer"
                          value="{{this.insurer | uppercase}}" disabled required />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Policy Number</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input type="text" class="form-control" name="policyNumber" id="policyNumber"
                          value="{{this.policyNumber}}" disabled required />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Patient Name</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <div class="sum-insured-input">
                          <div class="form-group" *ngIf="!individualInsuranceClaimant">
                            <input type="text" class="form-control" name="claimant" id="claimant"
                              value="{{this.insured}}" disabled required />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Relation with Claimant</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input type="text" class="form-control" name="relation" id="relation" value="{{this.relation}}"
                          disabled required />
                        <div *ngIf="relation.invalid && relation.touched " class="error-message">
                          <div *ngIf="relation.errors.required">
                            Relation is required.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Treatment for</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input type="text" class="form-control city-input" [typeahead]="diseaseList" [isAnimated]="true"
                          #ailments="ngModel" name="ailment" [(ngModel)]="ailment" maxlength="50" required />
                        <div class="">
                          <div *ngIf="ailments.invalid && ailments.touched " class="error-message">
                            <div *ngIf="ailments.errors.required">
                              Field is required.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <p class="title mt-4 mendate">E-mail</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input type="text" class="form-control" name="email" id="email" value="{{this.email}}" disabled
                          required />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Mobile no.</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input type="text" class="form-control" name="mobile" id="mobile" value="{{this.mobile}}"
                          disabled required />
                        <div *ngIf="mobile.invalid && mobile.touched" class="error-message">
                          <div *ngIf="mobile.errors.required">
                            Mobile number is required.
                          </div>
                          <div *ngIf="mobile.errors.maxlength">
                            Mobile number should not be greater than 10 digits.
                          </div>
                          <div *ngIf="mobile.errors.minlength || !mobile.errors.pattern && !mobile.errors.required">
                            Mobile number must be at least 10 digits long.
                          </div>
                          <div *ngIf="mobile.errors.pattern && !mobile.errors.minlength && !mobile.errors.required">
                            Invalid mobile number.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Card no.</p>
                    <div class="sum-insured-input">
                      <div class="form-group" *ngIf="!individualInsuranceClaimant">
                        <input type="text" name="cardNumber" class="form-control" value="{{this.cardNumber}}"
                          [(ngModel)]="cardNumber" disabled required>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Admission Date</p>
                    <div class="sum-insured-input reg-date-input proposal-date-input">
                      <div class="input-group">
                        <div class="input-group addon">
                          <img
                            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                          <p-calendar [touchUI]="true" [readonlyInput]="true" placeholder="Date" name="regDate"
                            [(ngModel)]="regDate" keepInvalid dateFormat="dd/mm/yy" [monthNavigator]="true"
                            [yearNavigator]="true" yearRange="1900:2100"></p-calendar>
                          <span class="input-group-addon" id="basic-addon-dueDate"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Estimated Claim Amount</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input type="text" name="estimatedAmount" class="form-control" maxlength="9" pattern="^[0-9]*$"
                          [(ngModel)]="estimatedAmount" #estAmount="ngModel" inputmode="numeric" required>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Hospital State</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input type="text" name="hospitalState" class="form-control" pattern="[a-zA-Z\s]+"
                          maxlength="200" [(ngModel)]="hospitalState" #hpState="ngModel" required>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Hospital City</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input type="text" name="hopitalCity" class="form-control" pattern="[a-zA-Z\s]+" maxlength="50"
                          [(ngModel)]="hospitalCity" #hpCity="ngModel" required>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Hospital Name</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input type="text" name="hospitalName" class="form-control" pattern="[a-zA-Z\s]+"
                          maxlength="200" [(ngModel)]="hospitalName" #hpName="ngModel" required>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Discharge Date</p>
                    <div class="sum-insured-input reg-date-input">
                      <div class="input-group">
                        <div class="input-group addon">
                          <img
                            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                          <p-calendar [touchUI]="true" [readonlyInput]="true" placeholder="Date" name="dischargeDate"
                            [(ngModel)]="dischargeDate" keepInvalid dateFormat="dd/mm/yy" [monthNavigator]="true"
                            [yearNavigator]="true" yearRange="1900:2100"></p-calendar>
                          <span class="input-group-addon" id="basic-addon-dueDate"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="col-12">
                <div class="text-center top-gap-lg mb-4">
                  <button class="btn btn-bordered-blue" [disabled]="!formClaimIntimate.form.valid"
                    (click)="submitIntimateDetails()">Register Now</button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="intimate-successfull" *ngIf="intimateSuccessfull">
          <div class="container">
            <div class="col text-center">
              <h2 class="done-heading">Registration Done</h2>
              <img
                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/done-intimate.jpg">
            </div>
            <center class="sub-title mt-2">
              <p>THANK YOU</p>
            </center>
            <div class="col note text-center">
              <p>We have recieved your claim request. <br> your claim registration no. is <span
                  class="registrationNo">{{this.registrationNumber}}</span>.
              </p>
            </div>
            <div class="col footer-strip text-center">
              <p>For any queries, please reach us at:</p>
              <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
                class="img-responsive" width="40%" alt="Securenow">
              <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span>
              </p>
            </div>
          </div>
        </div>
        <div class="intimate-successfull" *ngIf="intimateFailure">
          <div class="container">
            <div class="col text-center">
              <h2 class="done-heading">Registration Fail</h2>
              <img
                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/ERROR.svg">
            </div>
            <center class="sub-title mt-2">
              <p>Error</p>
              <p>{{errorMessage}}</p>
            </center>
            <div class="col note text-center">
              <p>Oops..!! Claim request error. Please try after some time.</p>
            </div>
            <div class="col footer-strip text-center">
              <p>For any queries, please reach us at:</p>
              <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
                class="img-responsive" width="40%" alt="Securenow">
              <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span>
              </p>
            </div>
          </div>
        </div>
      </section> -->
      <!-- expanded -->
      <!-- <div class="spacer"></div>

      <div class="spacer"></div> -->
    </div>
  </div>
  <!-- view card ends -->

  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</Section>
